import type { Program } from 'models';
import type { EventContentObjectDataObject } from 'models/service';

import { EditEventFormModal } from './components';

type P = {
  eventId: string;
  isOpened: boolean;
  mode: 'duplicate' | 'edit';
  onCancel: () => void;
  onSuccess: (data: EventContentObjectDataObject) => Promise<void> | void;
  program?: Program;
};

export const EditEvent = ({ isOpened, ...rest }: P) => {
  // TODO: This is Hack. This is ruining accessibility
  if (!isOpened) {
    return null;
  }

  return <EditEventFormModal isOpened={isOpened} {...rest} />;
};
